import dynamic from "next/dynamic";
import { Suspense, useState } from "react";
import Modal from "../../Modal";

const Form = dynamic(() => import("./Form"), {
  suspense: true,
});

const Thankyou = dynamic(() => import("./Thankyou"), {
  suspense: true,
});

interface IBookingForm {
  modalopen: boolean;
  handleModalClose: () => void;
  address: string;
  mls: string;
}

export const BookingForm: React.FC<IBookingForm> = ({
  modalopen,
  handleModalClose,
  address,
  mls,
}) => {
  const [next, setNext] = useState(false);

  return (
    <div>
      <Modal
        className="w-96 model p-4"
        visible={modalopen}
        onClose={handleModalClose}
      >
        <Suspense fallback={<></>}>
          {next === true ? (
            <Thankyou />
          ) : (
            <Form
              onSubmit={() => {
                setNext(true);
              }}
              address={address}
              handleModalClose={handleModalClose}
              mls={mls}
            />
          )}
        </Suspense>
      </Modal>
    </div>
  );
};
export default BookingForm;
